var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmexCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "#006FCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60326 10.7932H7.05567L6.32946 9.20591L5.60326 10.7932ZM25.8461 7.77734H22.1243L21.2166 8.65036L20.3996 7.77734H12.5022L11.776 9.20591L11.0498 7.77734H7.87264V8.41226L7.50954 7.77734H4.78629L2.15381 13.3329H5.33094L5.69404 12.4599H6.60179L6.96489 13.3329H10.5051V12.698L10.7774 13.3329H12.5929L12.8653 12.6186V13.3329H20.1273L21.035 12.4599L21.852 13.3329H25.5738L23.2136 10.5551L25.8461 7.77734ZM14.8623 12.5392H13.8638V9.44401L12.3206 12.5392H11.4129L9.86969 9.44401V12.5392H7.78187L7.41877 11.6662H5.24016L4.87706 12.5392H3.69699L5.60326 8.57099H7.14644L8.87117 12.3012V8.57099H10.5959L11.9575 11.2694L13.2284 8.57099H14.9531V12.5392H14.8623ZM23.8491 12.5392H22.4874L21.3074 11.19L19.9457 12.5392H15.8609V8.57099H20.0365L21.3074 9.84084L22.669 8.57099H23.9398L21.9428 10.5551L23.8491 12.5392ZM16.8594 9.36465V10.0789H19.1288V10.8726H16.8594V11.6662H19.4011L20.5812 10.4758L19.4919 9.36465H16.8594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexCard);
export default __webpack_public_path__ + "static/media/amex-card.8d95419b72cbc08625746fa780ef90d8.svg";
export { ForwardRef as ReactComponent };